import { useCallback } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import {
  clearQuickCaptureNotifications,
  useQuickCaptureNotifications,
} from './quickCaptureNotificationsState';
import { useTrelloMarkInboxNotificationsReadMutation } from './TrelloMarkInboxNotificationsReadMutation.generated';

export const useDismissQuickCaptureNotifications = () => {
  const quickCaptureNotifications = useQuickCaptureNotifications();
  const [markInboxNotificationsRead] =
    useTrelloMarkInboxNotificationsReadMutation();
  const { value: isQuickCaptureNotificationMutationEnabled } = useFeatureGate(
    'ghost_notification_inbox_read_mutation',
  );

  const dismissQuickCaptureNotifications = useCallback(async () => {
    if (!isQuickCaptureNotificationMutationEnabled) {
      return;
    }
    if (quickCaptureNotifications.length > 0) {
      // Optimistically update quickCaptureNotificationsState
      clearQuickCaptureNotifications();

      await markInboxNotificationsRead();
    }
  }, [
    quickCaptureNotifications,
    markInboxNotificationsRead,
    isQuickCaptureNotificationMutationEnabled,
  ]);

  return dismissQuickCaptureNotifications;
};
